<template>
  <div class="maintenance-parts-search-wrapper">
    <div class="columns is-centered">
      <div class="column is-8-desktop">
        <MaintenancePartsSearchFilters
          :series-options="series"
          :size-options="sizes"
          v-model:part-number-filter="partNumberFilter"
          v-model:series-filter="seriesFilter"
          v-model:size-filter="sizeFilter"
        />
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column is-10-desktop" v-if="searchCompleted && products.length">
        <MaintenancePartsSearchResults
          :products="products"
        />
      </div>
      <div v-else-if="searchCompleted" class="column is-12 no-results">No Maintenance Parts found.</div>
    </div>
  </div>
</template>

<script>
/* global series */

import MaintenancePartsSearchFilters from './components/MaintenancePartsSearchFilters.vue'
import MaintenancePartsSearchResults from './components/MaintenancePartsSearchResults.vue'

export default {
  name: 'MaintenancePartsSearch',
  components: {
    MaintenancePartsSearchFilters,
    MaintenancePartsSearchResults
  },
  data () {
    return {
      partNumberFilter: '',
      series: series,
      sizes: [],
      seriesFilter: '',
      sizeFilter: '',
      products: [],
      searchCompleted: false
    }
  },
  created: function () {
    var urlParams = [];
    (window.onpopstate = function () {
      var match
      var pl = /\+/g // Regex for replacing addition symbol with a space
      var search = /([^&=]+)=?([^&]*)/g
      var decode = function (s) { return decodeURIComponent(s.replace(pl, ' ')) }
      var query = window.location.search.substring(1)

      var filters = ['part_number', 'series', 'size']

      while ((match = search.exec(query))) {
        if (filters.indexOf(decode(match[1])) >= 0 && decodeURIComponent(match[2]) !== '') {
          urlParams.push({ name: decode(match[1]), value: decodeURIComponent(match[2]) })
        }
      }
    })()

    // if we have urlParams load the data from those, otherwise load from local storage if we have it
    if (urlParams.length) {
      this.partNumberFilter = ''
      this.seriesFilter = ''
      this.sizeFilter = ''

      urlParams.forEach(function (urlParam) {
        const paramValue = urlParam.value
        switch (urlParam.name) {
          case 'part_number':
            this.partNumberFilter = paramValue
            break
          case 'series':
            this.seriesFilter = paramValue
            break
          case 'size':
            this.sizeFilter = paramValue
            break
        }
      }, this)
    }

    this.buildUrl()
    this.getResults()
  },
  watch: {
    partNumberFilter: function () {
      this.seriesFilter = ''
      this.sizeFilter = ''

      this.buildUrl()
      this.getResults()
    },
    seriesFilter: function () {
      this.partNumberFilter = ''
      this.sizeFilter = ''

      this.buildUrl()
      this.getSizes()
      this.getResults()
    },
    sizeFilter: function () {
      this.buildUrl()
      this.getResults()
    }
  },
  methods: {
    buildUrl: function () {
      var query = ''
      if (this.partNumberFilter !== '') {
        if (query.length) {
          query = query + '&'
        }
        query = query + 'part_number=' + this.partNumberFilter
      }
      if (this.seriesFilter !== '') {
        if (query.length) {
          query = query + '&'
        }
        query = query + 'series=' + this.seriesFilter
      }
      if (this.sizeFilter !== '') {
        if (query.length) {
          query = query + '&'
        }
        query = query + 'size=' + this.sizeFilter
      }

      if (query.length) {
        history.replaceState(history.state, history.title, window.location.href.split('?')[0] + '?' + query)
      } else {
        history.replaceState(history.state, history.title, window.location.href.split('?')[0])
      }
    },
    async getSizes () {
      var postData = JSON.stringify({ series_id: this.seriesFilter })
      var rootObj = this

      fetch(
        '/get-series-sizes',
        {
          method: 'POST',
          body: postData,
          headers: { 'Content-type': 'application/json; charset=UTF-8' }
        }
      )
        .then(response => response.json())
        .then(function (json) {
          rootObj.sizes = json.sizes
        })
        .catch(function (err) {
          // eslint-disable-next-line
          console.log(err)
        })
    },
    async getResults () {
      this.searchCompleted = false

      if (this.partNumberFilter !== '' || (this.seriesFilter !== '' && this.sizeFilter !== '')) {
        var postData = JSON.stringify({
          part_number: this.partNumberFilter,
          series_id: this.seriesFilter,
          size: this.sizeFilter
        })

        var rootObj = this

        fetch(
          '/get-maintenance-products',
          {
            method: 'POST',
            body: postData,
            headers: { 'Content-type': 'application/json; charset=UTF-8' }
          }
        )
          .then(response => response.json())
          .then(function (json) {
            rootObj.searchCompleted = true
            rootObj.products = json.products
          })
          .catch(function (err) {
            // eslint-disable-next-line
            console.log(err)
          })
      }
    }
  }
}
</script>
